import { render, staticRenderFns } from "./operatemplateComponentWindow.vue?vue&type=template&id=0fa6103f"
import script from "./operatemplateComponentWindow.vue?vue&type=script&lang=js"
export * from "./operatemplateComponentWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports